
import { USER_ACTION, SET_LANGUAGE, SET_USERINFO, LOG_OUT, SET_USER_INFO } from "@/actions/user";
import { setStoreItem, getUserInfo, removeUserInfo, setUserInfo } from "@/common/store";
import { OmniHeroesCommunity } from '@/types'
import SimulatorModel from '@/api/simulator'

export const userReducer = function user(state: OmniHeroesCommunity.UserState = {
    language: window.location.href.indexOf('/simulator') > -1 ? SimulatorModel.getLanguage() : (localStorage.getItem('language') || sessionStorage.getItem('language') || 'en'),
    // language: 'en',
    userInfo: getUserInfo(),
    flowerInfo: undefined
}, action: USER_ACTION) {
    switch(action.type) {
        case SET_LANGUAGE.type:
            const d = <typeof SET_LANGUAGE>action;
            setStoreItem('language', window.location.href.indexOf('/simulator') > -1 ? SimulatorModel.getLanguage() : d.language)
            return {
                ...state,
                language: d.language
            }
        case SET_USER_INFO.type:
            const ud = (<typeof SET_USER_INFO>action)
            setUserInfo(ud.userInfo)
            return {
                ...state,
                userInfo: ud.userInfo
            }
        case LOG_OUT.type:
            // 删除session
            removeUserInfo()
            return {
                ...state,
                userInfo: undefined
            }
        default:
            return state
    }
}